import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { faTrashAlt } from 'fontawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'

interface Props {
    deleteConfirmationMessage: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'DeleteConfirmButton',
  props: {
    deleteConfirmationMessage: {}
  },
  emits: ['delete'],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit
const onClickDelete = (): void => {
    if (confirm(props.deleteConfirmationMessage)) {
        emit('delete')
    }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onClick: onClickDelete }, [
    _createVNode(_unref(FontAwesomeIcon), {
      icon: _unref(faTrashAlt),
      size: "lg"
    }, null, 8, ["icon"])
  ]))
}
}

})